import { bauValidatePassword } from './bauPasswordValidations';
import { isCpcsIntegrationEnabled } from './passwordConstants';
import { cpcsValidatePassword } from './cpcsValidations';
import type { PasswordValidationResult } from './cpcsValidations';

type ValidatePasswordOptions = Parameters<typeof bauValidatePassword>[1];

const validatePassword = (
  value: string,
  options: ValidatePasswordOptions = {},
): PasswordValidationResult =>
  isCpcsIntegrationEnabled()
    ? cpcsValidatePassword(value, options)
    : bauValidatePassword(value, options);

export { validatePassword };
